import { FC } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import LeadControlTaskList from '../../modules/tasks/components/LeadControlTaskList';

const LeadControlTasksPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'app.leadControlTasks' })}
      </PageTitle>
      <div className="row">
        <div className="col-12">
          <LeadControlTaskList />
        </div>
      </div>
    </>
  );
};

export { LeadControlTasksPage };
